export const REPORT_VELOCITY = 'velocity';
export const REPORT_BURNUP = 'burnup';
export const REPORT_BURNDOWN = 'burndown';
export const REPORT_BURNUP_LEGACY = 'burnupChart';
export const REPORT_CUMULATIVE_FLOW_DIAGRAM = 'cumulative';

export const APP_ID = 'software.reports.report-page';
